// src/components/PopoverWrapper.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import PurchaseRequestConversationFooter from "./PurchaseRequestConversationFooter";

const PopoverWrapper = ({
  isOpen,
  position,
  userName,
  instituteName,
  onClose,
  userId,
  prVendorId,
  prId,
  iid,
}) => {
  if (!isOpen) return null;

  return (
    <div className="popover-overlay">
      <div
        className="popover-content"
        style={{
          top: position.top,
          left: position.left,
          position: "fixed",
        }}
      >
        <div
          className="popover-header"
          style={{ background: "#0465AC", color: "white" }}
        >
          <div>
            <p style={{ color: "white", fontSize: "22px" }}>{userName}</p>
            <p>{instituteName}</p>
          </div>
          <div onClick={onClose} style={{ cursor: "pointer" }}>
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </div>
        </div>
        <PurchaseRequestConversationFooter
          vendorId={userId}
          prId={prId}
          prVendorId={prVendorId}
          iid={iid}
          selectedClientName ={userName}
        />
      </div>
    </div>
  );
};

export default PopoverWrapper;
